import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaCheck, FaTimes, FaPaperPlane, FaInfoCircle, FaFilePdf, FaFileWord } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import OrderTracker from "./OrderTracker";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import Messages from "../layout/messages";
import Loader from "../../components/Loader";
import './order.css'

const STATUS_OPTIONS = [
  { label: "Shipped", value: 8 },
  { label: "Out for delivery", value: 9 },
  { label: "Delivered", value: 10 },
];

const VendorOrderDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const Orders_data = state?.orders;
  console.log(Orders_data,"Orders_data")
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentStep, setCurrentStep] = useState(-1);
  const [statusLabel, setStatusLabel] = useState("Quotation Approved");
  const [progress, setProgress] = useState(0);
const [invoiceSent, setInvoiceSent] = useState(false);
const [showMessages, setShowMessages] = useState(false);
const [chatContext, setChatContext] = useState({
  rfq: null,
  supplier: null,
});
const [loadingConfirm, setLoadingConfirm] = useState(false);
const [loadingReject, setLoadingReject] = useState(false);
const [loadingInvoice, setLoadingInvoice] = useState(false);
const [actionStatus, setActionStatus] = useState();

const [orderQueryCount, setOrderQueryCount] = useState(0);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const [loading, setLoading] = useState(false);

  const created = Orders_data?.created || "2025-10-20";
  const delivery = Orders_data?.delivery_date || "2025-10-30";
  const status = Orders_data?.status || 3;

  useEffect(() => {
    const stepMap = { 3: 0, 6: 1, 7: 2, 8: 3, 9: 4, 10: 5,15:5 };
    const getStepFromStatus = (status) =>
      ![1, 2].includes(status) ? stepMap[status] || 0 : -1;

    const statusValue = Orders_data?.status || 3;
    const step = getStepFromStatus(statusValue);
    setCurrentStep(step);

    const statusMap = {
      3: "Quotation Approved",
      6: "Awarded",
      7: "Invoice Raised",
      8: "Shipped",
      9: "Out for Delivery",
      10: "Delivered",
      15: "Completed",
      4:"Completed"
    };
    setStatusLabel(statusMap[statusValue]);
    setProgress(((step + 1) / 6) * 100);
  }, [Orders_data]);

  const getBadgeColor = () => {
    switch (statusLabel) {
      case "Delivered":
        return "bg-success";
      case "Rejected":
        return "bg-danger";
      case "Pending":
        return "bg-warning";
      default:
        return "bg-primary";
    }
  };
const handleUpdate = async (status) => {
  const setLoader = status === 6 ? setLoadingConfirm
                  : status === 4 ? setLoadingReject
                  : status === 7 ? setLoadingInvoice
                  : null;

  if (setLoader) setLoader(true);

  try {
    const body = {
      rfq_id: Orders_data?.id_rfq,
      supplier_id: Orders_data?.supplier_id,
      status,
    };

    if (status === 7 && !selectedFile) {
      toast.error("Please upload the invoice file before sending");
      if (setLoader) setLoader(false);
      return;
    }

    if (status === 7 && selectedFile) {
      const base64 = await toBase64(selectedFile);
      body.invoice_document = {
        name: selectedFile.name,
        type: selectedFile.type,
        data: base64,
      };
    }

    const res = await apicall.post(body, "updateQuotationStatus");

    if (res.success) {
      toast.success(res.message);
      navigate('/orders')

      if (status === 7) {
        setSelectedFile(null);
        setShowModal(false);
        setInvoiceSent(true);
      } else {
        setTimeout(() => window.location.reload(), 800);
      }
    } else {
      toast.error(res.message || "Update failed");
    }
  } catch (error) {
    console.error("Error updating status:", error);
    toast.error("Something went wrong");
  } finally {
    if (setLoader) setLoader(false); // stop only the clicked button's loader
  }
};


useEffect(() => {
  if (Orders_data?.status) {
    setActionStatus(Number(Orders_data.status)); 
  }
  if (!Orders_data?.id_rfq) return;

  const fetchQueryCount = async () => {
    try {
      const res = await apicall.get(
        `order/query-count?rfq_id=${Orders_data.id_rfq}&user_id=${userDetails.id}`
      );
    if (res.success && res.data?.length > 0) {
        setOrderQueryCount(res.data[0].total);
      } else {
        setOrderQueryCount(0);
      }
    } catch (err) {
      console.error("Failed to fetch order query count");
    }
  };

  fetchQueryCount();
}, [Orders_data]);

const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const CONFIRMED_STATUSES = ["6", "7", "8", "9", "10", "15"];
const INVOICE_SENT_STATUSES = ["7", "8", "9", "10", "15"];

const disableConfirmOrder = CONFIRMED_STATUSES.includes(status);
const disableReject =status === "4" || CONFIRMED_STATUSES.includes(status);

const disableSendInvoice = INVOICE_SENT_STATUSES.includes(status);


const openChatWindow = (supplierId) => {
  const context = {
    Orders_data,
    supplier: supplierId,
    context: "ORDER" 
  };

  localStorage.setItem("chatContext", JSON.stringify(context));

  // open chat in new tab
  window.open("/chat", "_blank");
};
const handleStatusChange = async (statusCode) => {
  setActionStatus(statusCode);

  try {
    const body = {
      status: statusCode,
      rfq_id:Orders_data?.id_rfq,
      supplier_id:Orders_data?.supplier_id
    };

    const res = await apicall.post(body, "updateQuotationStatus");

    if (res.success) {
      toast.success("Timeline updated");
      navigate('/orders')
    } else {
      toast.error(res.message || "Update failed");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};

  return (
    <div className="container my-4">
      <div className="mb-3">
        <p className="fw-semibold">
          <FaArrowLeft
            className="me-2 cursor-pointer"
            size={20}
            onClick={() => navigate(-1)}
          />
          Back to Dashboard
        </p>
      </div>

<div className="row g-3 align-items-stretch">
        <div className="col-lg-8">
          <div className="card p-3 mb-3 shadow-sm" style={{ borderRadius: "10px" }}>
            <div className="d-flex justify-content-between align-items-center">
              <h6 className=" mb-0">Order Status</h6>
              <div>
                <span className={`badge ${getBadgeColor()} me-2`}>
                  {statusLabel}
                </span>
                {/* {status < 10 && (
                  <span className="badge bg-secondary">In Progress</span>
                )} */}
              </div>
            </div>

            <div className="text-muted small mt-2">
              Tracking Number:{" "}
              <strong>{Orders_data?.display_order_id}-{Orders_data?.display_id}</strong>
            </div>

            <div className="progress mt-3" style={{ height: "10px", borderRadius: "5px" }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${progress}%`,
                  background: "linear-gradient(90deg, #16a34a, #4ade80)",
                  transition: "width 0.5s ease-in-out"
                }}
              ></div>
            </div>

            <div className="d-flex justify-content-between text-muted small mt-2">
              <div>
                <strong>Order Date:</strong>{" "}
                {created ? new Date(created).toLocaleDateString("en-GB") : "-"}
              </div>
              <div>
                <strong>Expected Delivery:</strong>{" "}
                {delivery ? new Date(delivery).toLocaleDateString("en-GB") : "-"}
              </div>
            </div>
          </div>

          {currentStep !== -1 && (
            <OrderTracker currentStep={currentStep} OrdersData={Orders_data}/>
          )}

          <div className="card p-3 mb-3">
            <h6 className=" mb-3">Order Details</h6>
            {Orders_data?.products?.map((p, i) => (
              <div
                key={i}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <div>
                  <div className="fw-semibold">{p.item}</div>
                  <div className="text-muted small">
                    Qty: {p.quantity} × ${p.price}
                  </div>
                </div>
                <div className="fw-semibold">${p.amount}</div>
              </div>
            ))}
            <hr />
            <div className="text-end ">
              Total Amount:{" "}
              <span className="text-success">
                ${Orders_data?.total_price?.toLocaleString()}
              </span>
            </div>
          </div>
        </div>

<div className="col-12 col-lg-4 d-flex flex-column gap-3">
        <div className="card p-3 mb-3">
  <h6 className=" mb-3">Actions</h6>
  <div className="mb-3">
  <strong className="me-2">Status:</strong>

  <select
    className="form-select d-inline-block w-auto"
    value={actionStatus}
    onChange={(e) => handleUpdate(Number(e.target.value))}
  >
    <option value="">Select status</option>
    {STATUS_OPTIONS.map(opt => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
</div>


<button
  className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
  disabled={loadingConfirm || disableConfirmOrder}
  style={{
    color: disableConfirmOrder ? "white" : "#198754",
    backgroundColor: disableConfirmOrder ? "#198754" : "transparent",
    border: "1px solid #dee2e6",
    cursor: disableConfirmOrder ? "not-allowed" : "pointer",
    opacity: disableConfirmOrder ? 0.6 : 1,
  }}
  onClick={() => handleUpdate(6)}
>
  {loadingConfirm ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" />
      Confirming Order...
    </>
  ) : (
    <>
      <FaCheck style={{ marginRight: 10 }} />
      {disableConfirmOrder  ? "Confirmed" : "Confirm Order"}
    </>
  )}
</button>



<button
  className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
  disabled={disableReject}
  style={{
    color: "#dc3545",
    border: "1px solid #dee2e6",
    cursor: disableReject ? "not-allowed" : "pointer",
    opacity: disableReject ? 0.6 : 1,
  }}
  onClick={() => handleUpdate(4)}
>
  {loadingReject ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" />
      Rejecting Order...
    </>
  ) : (
    <>
      <FaTimes style={{ marginRight: 10 }} />
      {status === "4" ? "Rejected" : "Reject Order"}
    </>
  )}
</button>





<button
  className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
  disabled={disableSendInvoice || loadingInvoice}
  style={{
    backgroundColor: "#d01c4c",
    color: "white",
    cursor: disableSendInvoice ? "not-allowed" : "pointer",
    opacity: disableSendInvoice ? 0.6 : 1,
  }}
  onClick={() => setShowModal(true)}
>
  {loadingInvoice ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" />
      Sending Invoice...
    </>
  ) : (
    <>
      <FaPaperPlane style={{ marginRight: 10 }} />
      {disableSendInvoice  ? "Invoice Sent" : "Send Invoice"}
    </>
  )}
</button>





<button
  className="btn w-100 d-flex align-items-center justify-content-between"
  style={{
    color: "#0d6efd",
    border: "1px solid #dee2e6",
    backgroundColor: "transparent",
  }}
 onClick={() => openChatWindow(Orders_data?.supplier_id)}

>
  <span className="d-flex align-items-center">
    <FaInfoCircle style={{ marginRight: 10 }} />
    Request More Information
  </span>

  {orderQueryCount > 0 && (
    <span className="badge bg-danger ms-2">
      {orderQueryCount}
    </span>
  )}
</button>



</div>


          <div className="card p-3 mb-3">
            <h6 className=" mb-2">Contact Information</h6>
            <p className="mb-1 fw-semibold">{Orders_data?.user_name}</p>
            <p className="small mb-1">{Orders_data?.user_email}</p>
            <p className="small mb-0">{Orders_data?.user_mobile}</p>
          </div>

         <div className="card p-3">
  <h6 className=" mb-2">Attachments</h6>

{Orders_data?.documents && Orders_data.documents.length > 0 ? (
  Orders_data.documents.map((doc, index) => {
    const fileName = doc.document.split("/").pop();
    const ext = fileName.split(".").pop().toLowerCase();

    // Determine icon
    const icon =
      ext === "pdf" ? (
        <FaFilePdf className="me-2 text-danger" />
      ) : (
        <FaFileWord className="me-2 text-primary" />
      );

    // Use the correct full URL if available
    const fileUrl = doc.image_path || doc.document; // fallback to doc.document

    return (
      <div
        key={index}
        className="d-flex justify-content-between align-items-center mb-2 attachment-item"
      >
        <div className="d-flex align-items-center">
          {icon}
          <span>{fileName}</span>
        </div>

        <a
          href={fileUrl} // full URL
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-primary"
        >
          ⬇
        </a>
      </div>
    );
  })
) : (
  <p className="text-muted small mb-0">No attachments available</p>
)}

</div>

           <Modal show={showModal} onHide={() => {
    setShowModal(false);
    setSelectedFile(null); 
  }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
     <Modal.Body>
  <div
    style={{
      border: "2px dashed #dee2e6",
      padding: 20,
      textAlign: "center",
      cursor: "pointer",
    }}
    onClick={() => document.getElementById("fileInput").click()}
  >

        <p>Choose a file or drag and drop here</p>
        <p>JPEG, PNG and PDF</p>
        <button
          type="button"
          style={{background:" #d01c4c",color:"white"}}
          className="btn btn-outline-primary mt-2"
          onClick={(e) => {
            e.stopPropagation();
            document.getElementById("fileInput").click();
          }}
        >
          Browse File
        </button>
  </div>
<input
  type="file"
  id="fileInput"
  style={{ display: "none" }}
  onChange={(e) => setSelectedFile(e.target.files[0])}
  accept=".jpeg,.jpg,.png,.pdf"
/>

{selectedFile && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 15,
      gap: 10,
      flexWrap: "wrap",
    }}
  >
    <p style={{ margin: 0 }}>{selectedFile.name}</p>
    <FaTrash
      style={{ cursor: "pointer", color: "#d01c4c",marginLeft:"10px" }}
      onClick={() => setSelectedFile(null)}
      title="Remove file"
    />
  </div>
)}

{selectedFile && (
  <Button
    className="mt-3 w-100"
    onClick={() => handleUpdate(7)}
    style={{ background: "#d01c4c", border: "none" }}
    disabled={loadingInvoice}
  >
   {loadingInvoice ? "Send Invoice...": "Send Invoice"} 
  </Button>
)}
</Modal.Body>

      </Modal>
        </div>
      </div>
    </div>
  );
};

export default VendorOrderDetails;
